import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=25fbb92e&scoped=true"
import script from "./NotFoundPage.vue?vue&type=script&lang=ts"
export * from "./NotFoundPage.vue?vue&type=script&lang=ts"
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=25fbb92e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fbb92e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fbb92e')) {
      api.createRecord('25fbb92e', component.options)
    } else {
      api.reload('25fbb92e', component.options)
    }
    module.hot.accept("./NotFoundPage.vue?vue&type=template&id=25fbb92e&scoped=true", function () {
      api.rerender('25fbb92e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/error/NotFoundPage.vue"
export default component.exports